import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { Constants } from "../../data/constants";
import { DateFilter } from "../../models/date-filte.interface";
import { GenderAgeStatistics } from "../../models/statistics/gender-age-statistics";
import { GenderStatistics } from "../../models/statistics/gender-statistics";
import { GlobalStatistics } from "../../models/statistics/global-statistics";
import { ResultGlobalStatisticsForLP } from "../../models/statistics/resultGlobalStaticsForLP";
import { RetentionRate } from "../../models/statistics/retentionRate";
import { SummaryStatics } from "../../models/statistics/summary-statics";
import { LocationAndDateFilter } from "../../models/LocationAndDateFilter";
import { AudienceStatisticsDto } from "../../models/statistics/audienceStatisticsDto.interface";

@Injectable({
  providedIn: "root",
})
export class AdminStatisticsService {
  constructor(private http: HttpClient) {}

  //Start Audience
  getSummaryChartBetweenDatesForLP(
    companyName: string | null,
    dateFilte: DateFilter,
    refreshCache: boolean
  ): Observable<SummaryStatics | null> {
    return this.http.post<SummaryStatics>(
      `${
        environment.APP_PORT + Constants.STATICS_ENDPOINT
      }/refreshCache/${refreshCache}/summaryStatics/dateBetween/companyName/` +
        companyName,
      dateFilte
    );
  }

  getSummaryStaticsInDateBetweenForAd(
    campaignHashedId: string | null,
    refreshCache: boolean,
    filter: LocationAndDateFilter
  ): Observable<SummaryStatics> {
    return this.http.post<SummaryStatics>(
      `${
        environment.APP_PORT + Constants.STATICS_ENDPOINT
      }/refreshCache/${refreshCache}/summaryStatics/dateBetween/adTitle/${campaignHashedId}`,
      filter
    );
  }

  /*  getSummaryStaticsForLP(locationEmail : string): Observable<SummaryStatics | null>{
    return this.http.get<SummaryStatics>(
      `${
        environment.APP_PORT + Constants.STATICS_ENDPOINT
      }/summaryStatics/locationEmail/`+locationEmail
    )
  } */

  //End Audience
  getSummaryStaticsInDateBetween(
    dateFilter: DateFilter,
    refreshCache: boolean
  ): Observable<SummaryStatics> {
    return this.http.post<SummaryStatics>(
      `${
        environment.APP_PORT + Constants.STATICS_ENDPOINT
      }/refreshCache/${refreshCache}/summaryStatics/allStaticsInDateBetween`,
      dateFilter
    );
  }
  getSummaryStaticsInDay(day: string | null): Observable<SummaryStatics> {
    return this.http.get<SummaryStatics>(
      `${
        environment.APP_PORT + Constants.STATICS_ENDPOINT
      }/summaryStatics/inDay/${day}`
    );
  }
  getViewsByGenderForAd(
    campaignHashedId: string
  ): Observable<GenderStatistics> {
    return this.http.get<GenderStatistics>(
      `${
        environment.APP_PORT + Constants.STATICS_ENDPOINT
      }/views/gender/ad/${campaignHashedId}`
    );
  }

  getViewsByAgeAndRangeForAd(
    filter: LocationAndDateFilter,
    campaignHashedId: string | null,
    refreshCache: boolean
  ): Observable<GenderAgeStatistics> {
    return this.http.post<GenderAgeStatistics>(
      `${
        environment.APP_PORT + Constants.STATICS_ENDPOINT
      }/refreshCache/${refreshCache}/views/ageRangeAndGender/${campaignHashedId}`,
      filter
    );
  }
  getRedirectionByAgeAndGenderForAd(
    campaignHashedId: string | null,
    filter: LocationAndDateFilter
  ): Observable<GenderAgeStatistics> {
    return this.http.post<GenderAgeStatistics>(
      `${
        environment.APP_PORT + Constants.STATICS_ENDPOINT
      }/redirection/ageRangeAndGender/${campaignHashedId}`,filter
    );
  }

  getcompletedByAgeRangeAndGenderForAd(
    campaignHashedId: string | null,
    filter: LocationAndDateFilter
  ): Observable<GenderAgeStatistics> {
    return this.http.post<GenderAgeStatistics>(
      `${
        environment.APP_PORT + Constants.STATICS_ENDPOINT
      }/completed/ageRangeAndGender/${campaignHashedId}`,
      filter
    );
  }

  getConsumersByGenderDemographicForLPAndAdTitle(
    companyName: string
  ): Observable<GenderAgeStatistics | null> {
    return this.http.get<GenderAgeStatistics>(
      `${
        environment.APP_PORT + Constants.STATICS_ENDPOINT
      }/consumers/genderDemographic/${companyName}`
    );
  }

  getViewsByGenderDemographicForLP(
    email: string,
    filter: DateFilter,
    refreshCache: boolean
  ): Observable<GenderAgeStatistics | null> {
    return this.http.post<GenderAgeStatistics>(
      `${
        environment.APP_PORT + Constants.STATICS_ENDPOINT
      }/refreshCache/${refreshCache}/views/genderDemographic/${email}`,
      filter
    );
  }
  getCompletedByGenderDemographicForLP(
    email: string,
    filter: DateFilter
  ): Observable<GenderAgeStatistics | null> {
    return this.http.post<GenderAgeStatistics>(
      `${
        environment.APP_PORT + Constants.STATICS_ENDPOINT
      }/completed/genderDemographic/${email}`,
      filter
    );
  }

  getGlobalStatisticsForAd(
    campaignHashedId: string | null,
    refreshCache: boolean,
    finished: boolean,
    locationPartner: string[]
  ): Observable<GlobalStatistics> {
    return this.http.post<GlobalStatistics>(
      `${
        environment.APP_PORT + Constants.STATICS_ENDPOINT
      }/refreshCache/${refreshCache}/adStatus/${finished}/globalStatistics/adTitle/${campaignHashedId}`,
      locationPartner
    );
  }

  getSummaryStaticsInDayForAd(
    campaignHashedId: string | null,
    isFinished: boolean,
    day: string | null,
    locationPartner: string[]
  ): Observable<SummaryStatics> {
    return this.http.post<SummaryStatics>(
      `${
        environment.APP_PORT + Constants.STATICS_ENDPOINT
      }/summaryStatics/inDay/adTitle/${campaignHashedId}/${isFinished}/${day}`,
      locationPartner
    );
  }

  getGlobalStaticsForLP(
    companyName: string,
    refreshCache: boolean
  ): Observable<ResultGlobalStatisticsForLP | null> {
    return this.http.get<ResultGlobalStatisticsForLP>(
      `${
        environment.APP_PORT + Constants.STATICS_ENDPOINT
      }/refreshCache/${refreshCache}/globalStatistics/companyName/` +
        companyName
    );
  }

  getUniqueConsumersByLP(
    email: string,
    isRefreshCache: boolean
  ): Observable<number> {
    return this.http.get<number>(
      `${
        environment.APP_PORT + Constants.STATICS_ENDPOINT
      }/uniqueConsumers/${isRefreshCache}/email/` + email
    );
  }

  getConsumersForLP(email: string): Observable<number> {
    return this.http.get<number>(
      `${environment.APP_PORT + Constants.STATICS_ENDPOINT}/consumers/${email}`
    );
  }
  getRetentionRate(
    email: string,
    filter: DateFilter,
    refreshCache: boolean
  ): Observable<RetentionRate | null> {
    return this.http.post<RetentionRate>(
      `${
        environment.APP_PORT + Constants.STATICS_ENDPOINT
      }/refreshCache/${refreshCache}/retentionRate/week/${email}`,
      filter
    );
  }

  getRetainedConsumers(
    email: string,
    refreshCache: boolean
  ): Observable<number> {
    return this.http.get<number>(
      `${
        environment.APP_PORT + Constants.STATICS_ENDPOINT
      }/refreshCache/${refreshCache}/retainedConsumers/${email}`
    );
  }

  getSummaryStaticsInDayForLP(
    email: string | null,
    day: string | null
  ): Observable<SummaryStatics> {
    return this.http.get<SummaryStatics>(
      `${
        environment.APP_PORT + Constants.STATICS_ENDPOINT
      }/summaryStatics/inDay/companyName/${email}/${day}`
    );
  }

  getFranchiseSummaryStatisticsBetweenDates(
    dateFilter: DateFilter,
    refreshCache: boolean,
    companyName: string | null
  ): Observable<SummaryStatics> {
    return this.http.post<SummaryStatics>(
      `${
        environment.APP_PORT + Constants.STATICS_ENDPOINT
      }/franchise/summary-statistics/date-range/${companyName}/refreshCache/${refreshCache}`,
      dateFilter
    );
  }

  getFranchiseGlobalStatistics(
    email: string,
    refreshCache: boolean
  ): Observable<AudienceStatisticsDto> {
    return this.http.get<AudienceStatisticsDto>(
      `${
        environment.APP_PORT + Constants.STATICS_ENDPOINT
      }/franchise/${email}/globalStatistics/refreshCache/${refreshCache}`
    );
  }

  getLocationPartnerGlobalStatistics(
    email: string,
    refreshCache: boolean
  ): Observable<AudienceStatisticsDto> {
    return this.http.get<AudienceStatisticsDto>(
      `${
        environment.APP_PORT + Constants.STATICS_ENDPOINT
      }/${email}/globalStatistics/refreshCache/${refreshCache}`
    );
  }

  getClicksByGenderDemographicForLocationPartners(
    email : string,
    dateFilter: DateFilter
  ): Observable<GenderAgeStatistics | null>{
    return this.http.post<GenderAgeStatistics>(
      `${
        environment.APP_PORT + Constants.STATICS_ENDPOINT
      }/clicks/genderDemographic/${email}`,dateFilter
    )
  }
}
